import { useGlobalStateStore } from "../../stores/store";
import { useEffect, useRef, useState } from "react";
import Popover from "./Popover";

const OddsValue = () => {
  const store = useGlobalStateStore();
  const isEnabled = useGlobalStateStore(
    (state) => state.filter.oddsValue.enabled
  );
  const min = useGlobalStateStore((state) => state.filter.oddsValue.min);
  const max = useGlobalStateStore((state) => state.filter.oddsValue.max);

  const mainCheckbox = useRef();
  const oddsValuesMin = useRef();
  const oddsValuesMax = useRef();

  const [isInvalidRange, setIsInvalidRange] = useState(false);

  const oddsChange = (name, value) => {
    store.setOdds(name, value);
  };

  // Enable/disable input fields based on enabled state
  useEffect(() => {
    if (oddsValuesMin.current && oddsValuesMax.current) {
      oddsValuesMin.current.disabled = !isEnabled;
      oddsValuesMax.current.disabled = !isEnabled;
    }

    // Reset to default values if checkbox is disabled
    if (!isEnabled) {
      oddsChange("min", 1);
      oddsChange("max", 10);
    }
  }, [isEnabled]);

  // Validate min/max range and set border color + range error flag
  useEffect(() => {
    if (!oddsValuesMin.current || !oddsValuesMax.current) return;
    const minVal = parseFloat(min);
    const maxVal = parseFloat(max);

    const isInvalid = minVal >= maxVal;
    setIsInvalidRange(isInvalid);

    oddsValuesMin.current.style.borderColor = isInvalid
      ? "red"
      : "var(--gray333)";
    oddsValuesMax.current.style.borderColor = isInvalid
      ? "red"
      : "var(--gray333)";
  }, [min, max]);

  return (
    <div className="odds-value">
      <div className="odds-value__wrap">
        <label className="odds-value__label" htmlFor="odds-min">
          Min
        </label>
        <input
          ref={oddsValuesMin}
          type="number"
          id="odds-min"
          className="odds-value__input odds-value__input--min"
          value={min ?? ""}
          step="0.1"
          min="1"
          onChange={(e) => {
            const value = e.target.value;
            oddsChange("min", value === "" ? "" : parseFloat(value));
          }}
          onBlur={(e) => {
            let value = parseFloat(e.target.value);
            if (isNaN(value) || value < 1) value = 1;
            oddsChange("min", value);
          }}
        />
      </div>

      <div className="odds-value__wrap">
        <label className="odds-value__label" htmlFor="odds-max">
          Max
        </label>
        <input
          ref={oddsValuesMax}
          type="number"
          id="odds-max"
          className="odds-value__input odds-value__input--max"
          value={max ?? ""}
          step="0.1"
          min="1"
          onChange={(e) => {
            const value = e.target.value;
            oddsChange("max", value === "" ? "" : parseFloat(value));
          }}
          onBlur={(e) => {
            let value = parseFloat(e.target.value);
            if (isNaN(value) || value < 1) value = 1;
            oddsChange("max", value);
          }}
        />
      </div>

      <div className="custom-checkbox">
        <input
          ref={mainCheckbox}
          type="checkbox"
          name="checkBoxOddsVal"
          id="checkBoxOddsVal"
          checked={isEnabled}
          onChange={(e) => {
            oddsChange("enabled", e.target.checked);
          }}
        />
        <label htmlFor="checkBoxOddsVal"></label>
        <Popover />
      </div>
    </div>
  );
};

export default OddsValue;
